module.exports = __webpack_public_path__ + "static/media/upload-icon.e0c54175.svg";